import React, { Component } from 'react';
import { Paper } from 'material-ui';
import { connect } from 'react-redux';
import {
  getMassRateChangeData,
  massRateChange,
} from '../../../stores/contracting/mass-rate-change/mass-rate-change-actions';
import { repairAllProducts, checkIfUpdatesExist } from '../../../utils/mass-rate-change-helpers';
import HeaderBar from './container-header.jsx';
import LeftNav from './left-nav/left-nav';
import RaisedButton from '../../tc-ui/raised-button-with-loader.jsx';
import ActionArea from './middle-action-area/action-area.jsx';
import RatesDetail from './rates-detail/rates-detail';
import R from 'ramda';

class MassRateChangeContainer extends Component {
  componentWillMount() {
    const { params, dispatch, location } = this.props;
    // location.query has locationName in it;
    dispatch(getMassRateChangeData({ contractId: params.contractId }))
      .then(() => dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_UPDATE_TYPE', payload: { updateType: params.updateType, locationName: location.query.locationName } }));
  }

  getToBeUpdatedList = allUpdateCategories => R.compose(
    R.filter(obj => obj),
    R.flatten,
    R.map(
      updateTypeAsKey => R.map(
        rateTypeAsKey => {
          if (checkIfUpdatesExist(rateTypeAsKey)(allUpdateCategories[updateTypeAsKey].products)) {
            return { updateType: updateTypeAsKey, rateType: rateTypeAsKey };
          }
        }
      )(['nett', 'discount', 'commission'])
    )
  )(['seasonRates', 'offers', 'extras'])

  render() {
    const { params, dispatch, saving, location, isDummyAccount, isAnAdmin, pureDocView, ...updateCategories } = this.props;
    const { contractId } = params;
    const toBeUpdatedList = this.getToBeUpdatedList(updateCategories);
    const massRateChangeFn = () => {
      const allRatesRepaired = ['seasonRates', 'offers', 'extras'].map(type => ({
        updateType: type,
        productUpdates: repairAllProducts(type, updateCategories[type].products),
      }));
      return dispatch(massRateChange(contractId, allRatesRepaired, toBeUpdatedList));
    };
    const getMassRateChangeDataFn = () => dispatch(getMassRateChangeData({ contractId: params.contractId }));

    const shouldHideAppBars = (isDummyAccount && !isAnAdmin)
    || pureDocView;
    return (
      <div
        className={shouldHideAppBars ? 'full-screen-page' : ''}
        style={shouldHideAppBars ? { padding: '0 128px' } : {}}
      >
        <Paper style={{ height: '600px' }}>
          <HeaderBar
            saving={saving}
            closePopOver={() => dispatch({ type: 'CLOSE_POPOVER_IN_MASS_RATE_CHANGE' })}
            massRateChange={massRateChangeFn}
            goToContract={() => this.context.router.goBack()}
            goToContractOrOpenPover={event => {
              if (R.isEmpty(toBeUpdatedList)) this.context.router.goBack();
              else dispatch({ type: 'OPEN_POPOVER_WHEN_LEAVING_MASS_RATE_CHANGE', payload: { popOverAnchorEl: event.currentTarget  } })
            }}
          />
          <LeftNav
            changeRateType={(newRateType, newUpdateType) => dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_RATE_TYPE', payload: { rateType: newRateType, updateType: newUpdateType } })}
            changeRoute={newUpdateType => {
              this.context.router.push({ pathname: `/contracting/mass-rate-change/${contractId}/${newUpdateType}`, query: location.query });
              dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_UPDATE_TYPE', payload: { updateType: newUpdateType } });
            }}
          />
          <ActionArea
            onChangeNotApplyTo={() => dispatch({ type: 'ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD' })}
            changeMeasure={measure => dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_MEASURE', payload: { retailNettMeasure: measure } })}
            changeRoundSettings={payload => dispatch({ type: 'CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE', payload })}
          />
          <RatesDetail/>

          <RaisedButton
            label="save changes"
            loader={saving}
            disabled={R.isEmpty(toBeUpdatedList)}
            style={{ float: 'right', marginTop: '8px', marginRight: '8px', marginBottom: '8px' }}
            secondary
            onTouchTap={massRateChangeFn}
          />
          <RaisedButton
            label="discard changes"
            loader={saving}
            disabled={R.isEmpty(toBeUpdatedList)}
            style={{ float: 'left', marginTop: '8px', marginLeft: '8px', marginBottom: '8px' }}
            primary
            onTouchTap={getMassRateChangeDataFn}
          />
        </Paper>
      </div>
    );
  }
};

const mapStateToProps = ({ contracting, user }) => ({
  updateType: contracting.massRateChange.get('updateType'),
  rateType: contracting.massRateChange.get('rateType'),
  saving: contracting.massRateChange.get('saving'),
  seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
  offers: contracting.massRateChange.get('offers').toJS(),
  extras: contracting.massRateChange.get('extras').toJS(),
  isDummyAccount: user.get('isDummyAccount'),
  isAnAdmin: user.get('isAnAdmin'),
  pureDocView: user.get('pureDocView'),
});
MassRateChangeContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(MassRateChangeContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/mass-rate-change-container.jsx